<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import TutorBillingRecordChips from '../TutorBillingRecordChips.vue'
import { useModalTutorBillingBulkConfirm } from '../../model/modal-tutor-billing-bulk-confirm.hook'

defineOptions({
  name: 'ModalTutorBillingBulkConfirm',
})

const {
  isOpen,
  isSaving,
  chips,
  isOverLimit,
  isValid,
  setClose,
  setConfirm,
} = useModalTutorBillingBulkConfirm()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    title="Are you sure you want to confirm new billing info for selected tutors?"
    class-name="modal-tutor-billing-bulk-confirm"
    is-close-button
    @click:overlay="setClose"
    @click:close="setClose"
  >
    <TutorBillingRecordChips :chips="chips" />

    <AppText
      v-if="isOverLimit"
      name="body2"
      color="red-500"
      class="modal-tutor-billing-bulk-confirm__hint"
    >
      Select up to 100 records
    </AppText>

    <template #controls>
      <BtnPrimary
        text="Confirm billing info"
        color="emerald"
        :disabled="!isValid || isSaving"
        @click="setConfirm"
      />
      <BtnSecondary
        text="Discard"
        :disabled="isSaving"
        @click="setClose"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalTutorBillingBulkConfirm.scss" />
